"use client";

export default function RemoveBgIllustration() {
  return (
    <div className="flex flex-col items-center gap-6 text-center text-white/70">
      <div className="flex h-28 w-28 items-center justify-center rounded-full bg-brand-primary/20 text-3xl">
        🪄
      </div>
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-white">Pronto para remover o fundo</h3>
        <p className="max-w-md text-sm">
          Faça upload de uma imagem em PNG, JPG ou WEBP para gerar um recorte nítido. Seus arquivos ficam disponíveis para download por 2 horas e são salvos no histórico local.
        </p>
      </div>
    </div>
  );
}
